export const toggleBar = () => window.speechstream.toggleBar();
